import React from 'react'
import { Tooltip } from '@mui/material'
import { QuestionMarkSharp } from '@mui/icons-material'
import { WrapTooltip } from './Styled'

const CustomTooltip = (props) => {
    const { icon, title, placement = "top", slotProps } = props

    return (
        <Tooltip
            title={title}
            placement={placement}
            slotProps={slotProps}
        >
            <WrapTooltip>
                {icon || <QuestionMarkSharp sx={{ fontSize: 10 }} />}
            </WrapTooltip>
        </Tooltip>
    )
}

export default CustomTooltip